module.exports = __webpack_public_path__ + "img/index_hu.5ac11790.png";